import { IApplicationState } from '../../../../types/types';
import { ISnackbarModel } from '../store/types';

export const snackbarTopSelector = (
    state: IApplicationState
): ISnackbarModel => {
    const snackbar = state.snackbarsStack.snackbars[state.snackbarsStack.snackbars.length - 1];
    return snackbar;
}
